import { IProposal } from "../types/proposal.interface";
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StateChecker {

    /**
     * Available statements:
     * 
     * 1. 'finished'
     * 2. 'quick'
     */
    public testState(state: IProposal, statement: string): boolean {
        if (statement === 'finished') {
            return !!state.id;
        }
        if (statement === 'quick') {
            return !state.customer || !state.designer;
        }
        if (statement === 'saved') {
            return !!state.id;
        }
        throw new Error(`Unknown statement: ${statement}`);
    }
}
